<template>
  <div>
    <el-card style="margin: 20px;">
      <div style="display:flex;justify-content: space-between">
        <div>
          <el-input
            v-model="query.business_center_id"
            clearable
            style="width:240px;margin-right:10px"
            placeholder="请输入商务中心id"
          />
          <el-input
            v-model="query.account_id"
            clearable
            style="width:240px;margin-right:10px"
            placeholder="请输入账号id"
          />
          <el-input
            v-model="query.product_id"
            clearable
            style="width:240px;margin-right:10px"
            placeholder="请输入商品id"
          />
          <el-input
            v-model="query.product_name"
            clearable
            style="width:240px;margin-right:10px"
            placeholder="请输入商品名称"
          />
          <el-input
            v-model="query.seller_id"
            clearable
            style="width:240px;margin-right:10px"
            placeholder="请输入店铺id"
          />
          <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
          <el-button icon="el-icon-refresh" type="info" @click="refush">重置</el-button>
        </div>
        <div>
          <el-button type="success" icon="el-icon-plus" @click="openCreate">创建</el-button>
        </div>
      </div>
    </el-card>
    <el-card style="margin: 20px">
      <el-table :data="tableData.list" border>
        <el-table-column
          prop="account_id"
          align="center"
          label="账号id"
        />
        <el-table-column
          prop="business_center_id"
          align="center"
          label="商务中心id"
        />

        <el-table-column
          prop="seller_id"
          label="店铺id"
          align="center"
        />

        <el-table-column
          prop="product_id"
          align="center"
          label="商品id"
        />
        <el-table-column
          prop="product_name"
          label="商品名称"
          align="center"
        />
        <el-table-column
          prop="video_id"
          label="视频id"
          align="center"
        >
          <template slot-scope="scope">
            <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
            >
              <!-- Popover 内容区域 -->
              <div v-if="Array.isArray(scope.row.video_id)">
                <el-tag
                  v-for="(item, index) in scope.row.video_id"
                  :key="index"
                  type="info"
                  size="mini"
                  style="margin: 2px 4px 2px 0"
                >
                  {{ item }}
                </el-tag>
              </div>
              <!-- 触发区域（显示一个按钮或一个 tag） -->
              <el-tag slot="reference" type="primary" size="mini">
                查看 {{ scope.row.video_id.length }} 个
              </el-tag>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="ROI"
          label="ROI"
          align="center"
        />
        <el-table-column
          prop="budget"
          label="预算"
          align="center"
        />
        <el-table-column
          prop="status"
          label="状态"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag :type="scope.row.status=='0'? 'info': scope.row.status=='1'? 'warning': scope.row.status == 2? 'success':'danger'">{{ scope.row.status_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="错误信息"
          prop="err_msg"
          align="center"
        />
        <el-table-column
          prop="name"
          align="center"
          label="创建人"
        />
        <el-table-column
          prop="created_at"
          label="创建时间"
          align="center"
        />
        <el-table-column
          label="操作"
          align="center"
        >
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="elAdUpd(scope.row)">修改</el-button>
            <el-button type="danger" size="mini" @click="delElAd(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :total="tableData.total"
        :page-sizes="[10]"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>
    <el-dialog :visible.sync="visible" :title="form.id?'修改广告设置':'新增广告设置'" width="500px">
      <el-form label-width="100px" class="newForm">
        <el-form-item label="账号id">
          <el-input v-model="form.account_id" />
        </el-form-item>
        <el-form-item label="商务中心id">
          <el-input v-model="form.business_center_id" />
        </el-form-item>
        <el-form-item label="店铺id">
          <el-input v-model="form.seller_id" />
        </el-form-item>
        <el-form-item label="商品id">
          <el-input v-model="form.product_id" />
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input v-model="form.product_name" />
        </el-form-item>
        <el-form-item label="视频id">
          <el-input v-model="form.video_id" type="textarea" :rows="2" placeholder="多个视频请用逗号隔开" @blur="businessBlur" />
        </el-form-item>
        <el-form-item label="ROI">
          <el-input v-model="form.ROI" />
        </el-form-item>
        <el-form-item label="预算">
          <el-input v-model="form.budget" />
        </el-form-item>
        <el-form-item label="创建人">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item>
          <el-button type="success" :loading="submit_loading" @click="onSubmit">提交</el-button>
          <el-button type="info" @click="visible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-drawer
      title="视频id"
      :visible.sync="drawer"
      :direction="'rtl'"
    >
      <div style="padding: 20px">
        <el-tag v-for="item,index in tag_list" :key="index">{{ item }}</el-tag>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  adElDel,
  adElementCreate,
  adElementList, adElementUpdate
} from '@/api/report/adx'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      query: {
        page: 1,
        page_size: 10,
        account_id: '',
        product_id: '',
        product_name: '',
        seller_id: '',
        business_center_id: ''
      },
      tableData: {
        list: [],
        total: 0
      },
      visible: false,
      submit_loading: false,
      id: null,
      form: {
        account_id: '',
        product_id: '',
        product_name: '',
        seller_id: '',
        business_center_id: '',
        video_id: '',
        name: '',
        budget: '',
        ROI: '',
        id: null
      },
      date_value: null,
      drawer: false,
      tag_list: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      adElementList(this.query).then(res => {
        this.tableData = res.data
      })
    },
    fetchPageSize(e) {
      this.query.page_size = e
      this.getList()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.getList()
    },
    openCreate() {
      this.visible = true
      this.form = {
        account_id: '',
        product_id: '',
        product_name: '',
        seller_id: '',
        business_center_id: '',
        video_id: '',
        name: '',
        budget: '',
        ROI: ''
      }
    },
    onSubmit() {
      const requiredFields = {
        account_id: '账号id',
        product_id: '商品id',
        product_name: '商品名称',
        seller_id: '店铺id',
        business_center_id: '商务中心id',
        name: '创建人',
        budget: '预算',
        ROI: 'ROI',
        video_id: '视频id'
      }

      for (const key in requiredFields) {
        if (!this.form[key] && this.form[key] !== 0) {
          this.$message.error(`${requiredFields[key]} 不能为空`)
          return
        }
      }
      this.submit_loading = true
      try {
        if (this.form.id) {
          adElementUpdate(this.form).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.$message.success('修改成功')
              this.visible = false
              this.getList()
            }
          })
        } else {
          adElementCreate(this.form).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.$message.success('新增成功')
              this.visible = false
              this.getList()
            }
          })
        }
        // eslint-disable-next-line no-empty
      } catch (e) { } finally {
        this.submit_loading = false
      }
    },
    elAdUpd(val) {
      console.log(val)
      this.form.id = val.id
      this.form.account_id = val.account_id
      this.form.product_id = val.product_id
      this.form.product_name = val.product_name
      this.form.seller_id = val.seller_id
      this.form.product_name = val.business_center_id
      this.form.video_id = Array.isArray(val.video_id) ? val.video_id.join(',') : ''
      this.form.name = val.name
      this.form.ROI = val.ROI
      this.form.budget = val.budget
      this.form.business_center_id = val.business_center_id
      this.visible = true
    },
    delElAd(val) {
      this.$confirm('确定删除数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        adElDel({ id: val }).then(res => {
          console.log(res)
          // eslint-disable-next-line eqeqeq
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.getList()
          }
        })
      })
    },
    businessBlur() {
      let val = this.form.video_id || ''
      val = val.replace(/，/g, ',').replace(/\s+/g, '')
      this.form.video_id = val
      console.log(val)
    },
    getDateValue() {
      console.log(this.date_value)
    },
    search() {
      this.getList()
    },
    refush() {
      this.query = {
        page: 1,
        page_size: 10,
        account_id: '',
        product_id: '',
        product_name: '',
        seller_id: '',
        business_center_id: ''
      }
      this.getList()
    },
    checkVideoId(val) {
      this.tag_list = val
      this.drawer = true
    }
  }
}
</script>

<style scoped>
.newForm >>> .el-input {
  /* 你的样式，比如宽度、边距、字体等 */
  background-color: #f5f5f5;
  font-size: 14px;
  width: 200px;
}
</style>
